<header class="header-menu">
    <div class="mobile-fix-menu"></div>
    <div class="container-fluid custom-padding">
        <div class="header-section">
            <div class="header-left">
               <app-brand-logo></app-brand-logo>
                <app-search-box></app-search-box>
            </div>
            <div class="header-center d-none d-xl-block">
                <ul class="sidebar-icon">
                    @for (item of header; track item) {
                        <li [class.active]="item.active">
                            <a [routerLink]="item.path">
                                @if(item.iconType === 'feather'){
                                    <app-feather-icon [icons]="item.icons" [class]="'bar-icon'"></app-feather-icon>
                                    } @else {
                                    <app-svg-icon [class]="item.class" [icons]="item.icons"></app-svg-icon>
                                    }
                            </a>
                        </li>
                    }
                </ul>
            </div>
            <div class="header-right">
                <ul class="option-list">
                    <li class="header-btn home-btn d-sm-none d-block">
                        <a class="main-link" [routerLink]="['/']">
                            <app-feather-icon [icons]="'home'"
                                [class]="'icon-light stroke-width-3 iw-16 ih-16'"></app-feather-icon>
                        </a>
                    </li>
                    <li class="header-btn custom-dropdown dropdown-lg add-friend">
                        <app-friend-request></app-friend-request>
                    </li>
                    <li class="header-btn custom-dropdown dropdown-lg btn-group message-btn">
                        <app-messages></app-messages>
                    </li>
                    <li class="header-btn custom-dropdown">
                        <app-mode></app-mode>
                    </li>
                    <li class="header-btn custom-dropdown d-xl-none d-block app-btn">
                        <app-mobile-menu></app-mobile-menu>
                    </li>
                    <li class="header-btn custom-dropdown profile-btn btn-group">
                        <app-user-profile></app-user-profile>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</header>